(() => {
 if (window.mightyMarrowsLandingReady) return;
 window.mightyMarrowsLandingReady=true;
 document.addEventListener('click',event=>{
  const link=event.target.closest('a[href="#mighty-marrows-picker"]');
  if(!link || !document.querySelector('[data-mighty-marrows-page]')) return;
  const target=document.querySelector('.product-information--inner .product-form__input') || document.querySelector('.product-information--inner');
  if(!target) return;
  event.preventDefault();target.id='mighty-marrows-picker';target.style.scrollMarginTop='110px';
  target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
 });
})();

/* Mighty Marrows content accents only. Do not change global chrome or product images. */
(() => {
  function start() {
    const root = document.querySelector('#main-content');
    if (!root || !root.querySelector('[data-mighty-marrows-page]') || root.dataset.mmAccentReady) return;
    root.dataset.mmAccentReady = 'true';
    const expression = /rgba?\(\s*(\d+(?:\.\d+)?)[, ]+\s*(\d+(?:\.\d+)?)[, ]+\s*(\d+(?:\.\d+)?)(?:\s*[,/]\s*([\d.]+))?\s*\)/g;
    const replace = value => value.replace(expression, (full,r,g,b,a) => +r >= 180 && +r > +g * 1.3 && +r > +b * 1.25 && (a === undefined || +a > 0) ? `rgba(76, 45, 38, ${a === undefined ? 1 : a})` : full);
    const observers = [], observed = new WeakSet(), shadows = new Set();
    const shadowColourReplace = value => replace(value).replace(/#([0-9a-f]{6}|[0-9a-f]{3})\b/gi,(full,hex)=>{
      const h=hex.length===3?hex.split('').map(x=>x+x).join(''):hex;
      const r=parseInt(h.slice(0,2),16),g=parseInt(h.slice(2,4),16),b=parseInt(h.slice(4,6),16);
      return r>=180 && r>g*1.3 && r>b*1.25 ? '#4C2D26' : full;
    });
    function shadowStyles(shadow) {
      shadows.add(shadow);
      let sheet=shadow.querySelector('style[data-mm-shadow-palette]');
      if(!sheet){sheet=document.createElement('style');sheet.dataset.mmShadowPalette='true';shadow.appendChild(sheet);}
      const source=[...shadow.querySelectorAll('style:not([data-mm-shadow-palette])')].map(x=>x.textContent).join('\n');
      const value=shadowColourReplace(source)+'\n'+[...pseudos.values()].join('\n');
      if(sheet.textContent!==value)sheet.textContent=value;
    }
    const pseudoSheet = document.createElement('style');
    pseudoSheet.dataset.mmAccentStyles = 'true'; document.head.appendChild(pseudoSheet);
    let serial = 0, timer, busy = false;
    const pending = new Set([root]);
    const pseudos = new Map();
    const observerOptions = {subtree:true,childList:true,attributes:true,attributeFilter:['class','style','open','aria-selected','aria-checked']};
    function queue(node) { if (busy) return; pending.add(root); clearTimeout(timer);timer=setTimeout(apply,100); }
    function observe(target) {
      if (observed.has(target)) return;observed.add(target);
      const observer = new MutationObserver(records => records.forEach(record => queue(record.target)));
      observer.observe(target,observerOptions);observers.push([observer,target]);
    }
    function properties(x, s, pseudo) {
      const result = [];
      const ownsText = pseudo ? s.content !== 'none' && s.content !== 'normal' : [...x.childNodes].some(n => n.nodeType === 3 && n.textContent.trim());
      if (ownsText) result.push('color','text-decoration-color');
      result.push('background-color','background-image','box-shadow');
      ['top','right','bottom','left'].forEach(side=>{if(parseFloat(s.getPropertyValue(`border-${side}-width`))>0 && !['none','hidden'].includes(s.getPropertyValue(`border-${side}-style`)))result.push(`border-${side}-color`);});
      if (parseFloat(s.outlineWidth)>0 && s.outlineStyle !== 'none') result.push('outline-color');
      if (x.namespaceURI === 'http://www.w3.org/2000/svg' && !['svg','defs','clipPath','mask','image'].includes(x.localName))result.push('fill','stroke');
      return result;
    }
    function scan(container) {
      const list = container.nodeType === 1 ? [container,...container.querySelectorAll('*')] : [...container.querySelectorAll('*')];
      for (const x of list) {
        if (['SCRIPT','STYLE','LINK','META','NOSCRIPT','IMG','PICTURE','VIDEO','SOURCE'].includes(x.tagName)) continue;
        if (x.shadowRoot) {observe(x.shadowRoot);shadowStyles(x.shadowRoot);scan(x.shadowRoot);}
        if (!x.getClientRects().length) continue;
        for (const pseudo of [null,'::before','::after']) {
          const s = getComputedStyle(x,pseudo);
          if (s.display === 'none' || s.visibility === 'hidden' || (pseudo && ['none','normal'].includes(s.content))) continue;
          const rules = [];
          for (const property of properties(x,s,pseudo)) {
            const value = s.getPropertyValue(property), next = replace(value);
            if (next === value) continue;
            if (!pseudo) x.style.setProperty(property,next,'important');
            else rules.push(`${property}:${next}!important`);
          }
          if (rules.length) {
            if (!x.dataset.mmPaintId) x.dataset.mmPaintId=String(++serial);
            const selector=`[data-mm-paint-id="${x.dataset.mmPaintId}"]${pseudo}`;
            pseudos.set(selector,`${selector}{${rules.join(';')}}`);
          }
        }
      }
    }
    function apply() {
      busy=true;observers.forEach(([o])=>o.disconnect());
      try {
        const nodes=[...pending];pending.clear();nodes.forEach(scan);
        const text=[...pseudos.values()].join('\n');if(pseudoSheet.textContent!==text)pseudoSheet.textContent=text;
        shadows.forEach(shadowStyles);
      } finally {observers.forEach(([o,target])=>o.observe(target,observerOptions));busy=false;}
    }
    observe(root);apply();
    root.addEventListener('pointerover',event=>queue(event.target));
    root.addEventListener('focusin',event=>queue(event.target));
    root.addEventListener('change',event=>queue(event.target));
    root.addEventListener('click',event=>queue(event.target.closest('.product-gallery-container') || event.target));
    document.addEventListener('shopify:section:load',()=>queue(root));
    window.addEventListener('load',()=>queue(root),{once:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

/* Link the collagen-puff mention to its exact FAQ and reveal the answer. */
(() => {
  if (window.mmPuffLinkReady) return;
  window.mmPuffLinkReady = true;
  const anchor = '#MightyMarrowsFaq-faq_TAiKaq';
  function reveal() {
    if (!document.querySelector('[data-mighty-marrows-page]')) return;
    const target = document.getElementById(anchor.slice(1));
    if (!target) return;
    target.open = true;
    target.style.scrollMarginTop = '110px';
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
    target.querySelector('summary')?.focus({preventScroll:true});
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="'+anchor+'"]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !document.querySelector('[data-mighty-marrows-page]')) return;
    event.preventDefault();
    if (location.hash !== anchor) history.pushState(null, '', anchor);
    reveal();
  });
  function onHash() { if (location.hash === anchor) reveal(); }
  window.addEventListener('hashchange', onHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onHash, {once:true});
  else onHash();
})();
